var _rect, _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLogoPlaceholder(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 360,
    height: 360,
    viewBox: "0 0 360 360",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 56,
    y: 56,
    width: 248,
    height: 248,
    rx: 124,
    fill: "#EEEFF5"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1003_13517)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M212.667 163.674L241.999 142.607V205.702L126.787 225.091L106.727 164.671L140.909 175.431L171.155 134.909L212.667 163.674Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1003_13517"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 146.545,
    height: 146.545,
    fill: "white",
    transform: "translate(106.727 106.727)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogoPlaceholder);
export default __webpack_public_path__ + "static/media/logo_placeholder.12fbb17fb0743edcd58bbe32062d646d.svg";
export { ForwardRef as ReactComponent };